import { useEffect, useState } from 'react';

import ChooseCompare from 'components/landing/choose_compare/choose_compare';
import { cleanDictForJson } from 'utils/secure-json';
import CtaStickyBanner from 'components/home/cta-sticky-banner/cta-sticky-banner';
import CustomHead from 'core/custom-head';
import dynamic from 'next/dynamic';
import Faq from 'components/landing/faq/faq';
import Footer from 'components/footer/footer';
import getCarName from 'utils/get-car-name';
import getConstants from 'utils/query-data-parser/landing/get-constant';
import Guide from 'components/landing/guide/guide';
import Header from 'components/home/header';
import { Header as HeaderSection } from 'components/header/header';
import HowMuch from 'components/landing/how-much/how-much';
import InfoToQuote from 'components/landing/info_to_quote/info_to_quote';
import InsuranceConcept from 'components/landing/insurance-concept/insurance-concept';
import InsuranceSlider from 'components/landing/insurance-slider/insurance-slider';
import InsuranceType from 'components/landing/insurance-type/insurance-type';
import LandingContextProvider from 'components/landing/context/landing-context-provider';
import LocalitiesListSection from 'components/landing/localities-list/localities-list-section';
import { PageInfoContextProvider } from 'context/PageInfoContext';
import PriceInfluence from 'components/landing/price-influence/price-influence';
import PropTypes from 'prop-types';
import ScriptContainer from 'components/container/script-container';
import Scroller from 'components/home/scroller';
import SeoTracking from 'components/seo/tracking/seo-tracking';
import TableLinkComponent from 'components/landing/index/table-link-component';
import TableResume from 'components/landing/index/table-resume';
import { useScroll } from 'hooks';
import { useTranslations } from 'next-intl';
import WhatIsIncluded from 'components/landing/what_is_included/what_is_included';
import WhoNeeds from 'components/landing/who_needs/who_needs';
import WhyCompare from 'components/landing/why_compare/why_compare';
import withHydrationOnDemand from 'react-hydration-on-demand';

const LandingTestSecondPart = dynamic(() => import('../components/landing/landing-table'));
const InsuranceConceptH = withHydrationOnDemand({ on: ['visible'] })(InsuranceConcept);
const HowMuchH = withHydrationOnDemand({ on: ['visible'] })(HowMuch);
const PriceInfluenceH = withHydrationOnDemand({ on: ['visible'] })(PriceInfluence);
const InsuranceTypeH = withHydrationOnDemand({ on: ['visible'] })(InsuranceType);
const WhatIsIncludedH = withHydrationOnDemand({ on: ['visible'] })(WhatIsIncluded);
const WhyCompareH = withHydrationOnDemand({ on: ['visible'] })(WhyCompare);
const InfoToQuoteH = withHydrationOnDemand({ on: ['visible'] })(InfoToQuote);
const ChooseCompareH = withHydrationOnDemand({ on: ['visible'] })(ChooseCompare);
const WhoNeedsH = withHydrationOnDemand({ on: ['visible'] })(WhoNeeds);
const FaqH = withHydrationOnDemand({ on: ['visible'] })(Faq);
const GuideH = withHydrationOnDemand({ on: ['visible'] })(Guide);
const LocalitiesListSectionH = withHydrationOnDemand({ on: ['visible'] })(LocalitiesListSection);
const FooterH = withHydrationOnDemand({ on: ['visible'] })(Footer);

const Landing = ({ culture, payload, carName }) => {
    const [loadTotalPage, setLoadTotalPage] = useState(false);
    const t = useTranslations('index.items');

    useEffect(() => {
        setTimeout(() => {
            setLoadTotalPage(true);
        }, 3000);
    }, []);

    useScroll((scroll) => {
        if (scroll > 0 && !loadTotalPage) {
            setLoadTotalPage(true);
        }
    }, [loadTotalPage]);

    return (
        <div style={{ backgroundColor: '#ec008b', height: '100vh', width: '100vw' }}>
            <ScriptContainer breadcrumbList={payload.page_context.page_breadcrumb_list}>
                <SeoTracking templateName="contentap" pageCode={payload.page_context.code} />
                <CustomHead pageInfo={payload} />
                <PageInfoContextProvider data={payload}>
                    <LandingContextProvider>
                        <CtaStickyBanner hideMobile />
                        <Scroller />
                        <Header />
                        <HeaderSection />
                        <TableResume>
                            <InsuranceSlider />
                            <TableLinkComponent id="ic" titleList={[t('1.title'), t('2.title')]}>
                                <InsuranceConceptH />
                            </TableLinkComponent>
                            <TableLinkComponent id="hm" titleList={[t('3.title'), t('4.title'), t('5.title')]}>
                                <HowMuchH
                                    data={
                                        payload.page_context.page_dinamic_data
                                            .best_price_coverage_list
                                    }
                                />
                            </TableLinkComponent>
                            <TableLinkComponent id="t5" titleList={[t('6.title')]}>
                                {loadTotalPage && (
                                    <LandingTestSecondPart
                                        carName={carName}
                                        culture={culture}
                                        payload={payload}
                                    />
                                )}
                            </TableLinkComponent>
                            <TableLinkComponent id="pi" titleList={[t('7.title')]}>
                                <PriceInfluenceH />
                            </TableLinkComponent>
                            <TableLinkComponent id="it" titleList={[t('8.title')]}>
                                <InsuranceTypeH />
                            </TableLinkComponent>
                            <TableLinkComponent id="wi" titleList={[t('9.title')]}>
                                <WhatIsIncludedH />
                            </TableLinkComponent>
                            <TableLinkComponent id="wc" titleList={[t('10.title')]}>
                                <WhyCompareH />
                            </TableLinkComponent>
                            <TableLinkComponent id="itq" titleList={[t('11.title')]}>
                                <InfoToQuoteH />
                            </TableLinkComponent>
                            <TableLinkComponent id="cm" titleList={[t('12.title')]}>
                                <ChooseCompareH />
                            </TableLinkComponent>
                            <TableLinkComponent id="wn" titleList={[t('13.title')]}>
                                <WhoNeedsH />
                            </TableLinkComponent>
                            <TableLinkComponent id="faq" titleList={[t('14.title')]}>
                                <FaqH />
                            </TableLinkComponent>
                            <GuideH
                                data={
                                    payload.page_context.page_dinamic_data
                                        .guide_list
                                }
                            />
                            <LocalitiesListSectionH/>
                            <FooterH />
                        </TableResume>
                    </LandingContextProvider>
                </PageInfoContextProvider>
            </ScriptContainer>
        </div>
    );
};

export async function getServerSideProps ({ locale, req, res }) {
    const data = req.apiData.data;

    const payload = {
        ...data,
        ...getConstants(data.page_context)
    };

    const carName = getCarName(
        payload.page_context.deep_level,
        payload,
        payload.template_type
    ) || null;

    return {
        props: {
            messages: (
                await import(`../messages/insurance-car-landing/${locale}.json`)
            ).default,
            culture: locale,
            payload: cleanDictForJson(payload),
            carName
        }
    };
}

Landing.propTypes = {
    culture: PropTypes.string,
    payload: PropTypes.object,
    carName: PropTypes.string
};

export default Landing;
